<ng-container *ngIf="itemInCard else noCard">
    <ng-container *ngIf="formArrayControl.controls.length === 0 && noItemLabel">{{noItemLabel}}</ng-container>
    <app-card [title]="title" *ngFor="let control of formArrayControl.controls; index as i; let isFirst = first; let isLast = last"
              class="ion-no-margin ion-no-padding">
        <ng-container
                *ngTemplateOutlet="itemContent;context:{control: control, index:i, isFirst:isFirst, isLast:isLast}"></ng-container>
    </app-card>
    <ng-container [ngTemplateOutlet]="addItemTpl"></ng-container>
</ng-container>

<ng-template #noCard>
    <span style="font-size: 12px;" *ngIf="formArrayControl.controls.length === 0 && noItemLabel">{{noItemLabel}}</span>
    <div *ngFor="let control of formArrayControl.controls; index as i;let isFirst = first; let isLast = last">
        <ng-container
                *ngTemplateOutlet="itemContent;context:{control: control, index:i, isFirst:isFirst, isLast:isLast}"></ng-container>
    </div>
    <ng-container [ngTemplateOutlet]="addItemTpl" *ngIf="buildNewItemForm"></ng-container>
</ng-template>


<ng-template #itemContent let-control='control' let-index='index' let-isFirst='isFirst' let-isLast='isLast'>
    <div style="display: flex; align-items: center;">
        <div class="ion-margin-end">
            <app-button iconName="chevron-down"
                        size="small"
                        *ngIf="collapsible && !isCollapsed(index)"
                        [withMargin]="false"
                        [withPadding]="false"
                        (clickEvent)="setCollapsed(true, index)"></app-button>
            <app-button iconName="chevron-right"
                        *ngIf="collapsible && isCollapsed(index)"
                        size="small"
                        [withMargin]="false"
                        [withPadding]="false"
                        (clickEvent)="setCollapsed(false, index)"></app-button>
        </div>
        <div style="flex-grow: 1;">
            <ng-container [ngTemplateOutletContext]="{itemFormGroup:control, collapsed: isCollapsed(index), index: index}"
                          [ngTemplateOutlet]="template"></ng-container>
        </div>
        <div class="ion-margin-start">
            <app-button iconName="chevron-up"
                        *ngIf="!isFirst && canReorder === true"
                        (click)="moveUp(index)"
                        [withMargin]="false"
                        [withPadding]="false"
                        size="small"></app-button>
            <app-button iconName="chevron-down"
                        *ngIf="!isLast && canReorder == true"
                        (click)="moveDown(index)"
                        [withMargin]="false"
                        [withPadding]="false"
                        size="small"></app-button>

            <app-button *ngIf="!mustConfirmDeletion && canDeleted()"
                        [withMargin]="false"
                        [withPadding]="false"
                        (click)="onDeletionConfirmed(index)"
                        iconName="trash"
                        size="small"></app-button>
            <app-confirmation-button [withMargin]="false"
                                     [withPadding]="false"
                                     (confirm)="onDeletionConfirmed(index)"
                                     size="small"
                                     [options]="{confirmationText: 'Confirmez-vous la suppression?', displayCancelButton:true}"
                                     *ngIf="mustConfirmDeletion && canDeleted()" iconName="trash">
            </app-confirmation-button>
        </div>
    </div>
</ng-template>


<ng-template #addItemTpl>
    <div class="d-flex justify-content-end m-y-4">
        <app-action-link *ngIf="maxElementSize === -1 || formArrayControl?.controls?.length < maxElementSize"
        (clickEvent)="onAddItem()">{{addItemLabel}}</app-action-link>
    </div>
</ng-template>

